(function() {
  'use strict';

  function fixLogoLink() {
    var logoLink = document.querySelector('.site-header__logo-link');
    if (logoLink) {
      logoLink.style.removeProperty('padding-top');
      logoLink.style.height = '64px';
    }
  }

  function fixLogoWidth() {
    var logo = document.querySelector('.site-header__logo');
    if (logo) {
      logo.style.setProperty('width', 'auto', 'important');
      logo.style.setProperty('min-width', '0', 'important');
      logo.style.setProperty('max-width', '240px', 'important');
      logo.style.setProperty('flex-basis', 'auto', 'important');
      logo.style.setProperty('flex-grow', '0', 'important');
      logo.style.setProperty('flex-shrink', '0', 'important');
    }
  }

  function lockKitQuantities() {
    document.querySelectorAll('.cart__item, .ajaxifyCart--product').forEach(function(item) {
      var text = item.innerText || '';
      if (text.indexOf('Kit Size') !== -1) {
        item.querySelectorAll('.js-qty__adjust, .js-qty__adjust--minus, .js-qty__adjust--plus').forEach(function(btn) {
          btn.disabled = true;
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.4';
        });
        var input = item.querySelector('.js-qty__num, input[name="updates[]"]');
        if (input) {
          input.readOnly = true;
          input.style.pointerEvents = 'none';
        }
        var wrapper = item.querySelector('.js-qty__wrapper');
        if (wrapper) {
          wrapper.style.cssText += 'min-width:160px !important; width:160px !important; max-width:160px !important; overflow:visible !important;';
          var num = wrapper.querySelector('.js-qty__num');
          if (num) {
            num.style.cssText += 'width:90px !important; min-width:90px !important; max-width:90px !important; font-size:12px !important;';
          }
          wrapper.style.opacity = '0.5';
        }
      }
    });

    fixLogoLink();
    fixLogoWidth();
  }

  lockKitQuantities();
  document.addEventListener('DOMContentLoaded', lockKitQuantities);

  [100, 300, 600, 1000, 2000].forEach(function(ms) {
    setTimeout(fixLogoWidth, ms);
  });

  var observer = new MutationObserver(lockKitQuantities);
  observer.observe(document.body, { childList: true, subtree: true });

})();